import React from 'react';
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CenterReportMain from "../components/CenterReportMain";

const CenterReport = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Center report" />

        {/* DashBoardLayerSix */}
        <CenterReportMain />



      </MasterLayout>
    </>
  );
}
export default CenterReport;